import { useTranslation } from "react-i18next";
import { BookOpen, Clock, Scale, Mountain, CheckCircle2, Circle, ArrowRight } from "lucide-react";

export default function InsightsGuide({ entries, onNavigate }) {
  const { t } = useTranslation();
  const steps = [
    { id: "log", tab: "journal", Icon: BookOpen, done: entries.some((e) => e.traded_on && e.pnl != null) },
    { id: "time", tab: "journal", Icon: Clock, done: entries.some((e) => e.entry_time) },
    { id: "grade", tab: "grader", Icon: Scale, done: entries.some((e) => e.grader_data) },
    { id: "climb", tab: "climb", Icon: Mountain, done: entries.some((e) => e.climb_plan_id) },
  ];
  const left = steps.filter((s) => !s.done).length;
  if (!left) return null;
  return (
    <div data-testid="insights-guide" className="rounded-2xl border border-amber-200 bg-amber-50/60 p-5">
      <div className="text-sm font-semibold text-slate-900">{entries.length ? t("insights.guide.titlePartial") : t("insights.guide.titleEmpty")}</div>
      <p className="mt-1 text-xs text-slate-600">{t("insights.guide.body")}</p>
      <ol className="mt-4 grid gap-2 sm:grid-cols-2">
        {steps.map((s, i) => (
          <li key={s.id} data-testid={`insights-guide-step-${s.id}`} className={`flex items-start gap-3 rounded-xl border bg-white p-3 ${s.done ? "border-emerald-200 opacity-70" : "border-slate-200"}`}>
            {s.done ? <CheckCircle2 size={16} className="mt-0.5 text-emerald-600 shrink-0" /> : <Circle size={16} className="mt-0.5 text-slate-300 shrink-0" />}
            <div className="min-w-0 flex-1">
              <div className="flex items-center gap-1.5 text-sm font-semibold text-slate-900"><s.Icon size={13} className="text-blue-800" />{i + 1}. {t(`insights.guide.${s.id}.title`)}</div>
              <p className="mt-0.5 text-xs text-slate-600 leading-relaxed">{t(`insights.guide.${s.id}.body`)}</p>
              {!s.done && (
                <button type="button" data-testid={`insights-guide-go-${s.id}`} onClick={() => onNavigate?.(s.tab)}
                  className="mt-2 inline-flex items-center gap-1 text-xs font-semibold text-blue-800 hover:text-blue-700">
                  {t(`insights.guide.${s.id}.cta`)} <ArrowRight size={12} />
                </button>
              )}
            </div>
          </li>
        ))}
      </ol>
    </div>
  );
}
